export const INTERACTIVE_CARD_RESPONSE_MESSAGE = 'INTERACTIVE_CARD_RESPONSE_MESSAGE';